import { useGetOrders } from "hooks/order";
import { Columns, MobileColumns } from "./columns";
import DashboardHeader from "./components/DashboardHeader";
import Table from "rc-table";
import { useEffect, useState } from "react";
import { Pagination } from "shared";
import "./Dashboard.scss";

const Dashboard: React.FC = () => {
  const [page, setPage] = useState(1);
  const { data, refetch } = useGetOrders(page);

  useEffect(() => {
    refetch();
  }, [page, refetch]);
  return (
    <div className="dashboard__container">
   
      <DashboardHeader />

      <div className="dashboard">
        <h1>Lista Zleceń</h1>
        
        {/* Desktop Table */}
        <Table
          rowKey="id"
          className="companies-table desktop-table"
          data={data?.data}
          columns={Columns()}
        />

        {/* Mobile Table */}
        <Table
          rowKey="id"
          className="companies-table mobile-table"
          data={data?.data}
          columns={MobileColumns()}
          showHeader={false}
        />
        
        {data?.meta && data?.meta?.lastPage > 1 && (
          <Pagination
            totalPages={data?.meta?.lastPage}
            currentPage={data?.meta?.currentPage || page}
            onPageChange={(e: any) => setPage(e)}
          />
        )}
      </div>
    </div>
  );
};

export default Dashboard;
